<template>
    <span
        v-if="item.received"
        class="flex flex-col gap-[2px] justify-center items-center"
    >
        <span class="inline-flex items-center px-3 py-0.5 font-medium rounded-full bg-emerald-50 dark:bg-emerald-500/20 text-emerald-500 dark:text-emerald-400 capitalize text-sm w-fit">
            Received
        </span>
        <p
            class="text-left text-slate-500 dark:text-slate-400 text-xs font-normal leading-none"
            v-show="item.date_received"
        >
            {{ $filters.formatDate(item.date_received) }}
        </p>
    </span>
    <span
        v-else
        class="flex flex-col gap-[2px] justify-center items-center"
    >
        <span class="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-700 px-3 py-0.5 font-medium text-slate-500 dark:text-slate-400 text-sm w-fit">
            Not received
        </span>
        <p
            class="text-left text-slate-500 dark:text-slate-400 text-xs font-normal leading-none"
            v-show="item.minimum_spend_deadline"
        >
            Due: {{ $filters.formatDate(item.minimum_spend_deadline) }}
        </p>
    </span>
</template>

<script setup>
defineProps({
    item: { type: Object, required: true },
});
</script>
